// Copyright (c) 2026 Solartek LLC. All rights reserved.

import { useEffect, useState } from 'react';

export function useDebounced<T>(value: T, delay = 250): T {
  const [v, setV] = useState(value);
  useEffect(() => { const t = setTimeout(() => setV(value), delay); return () => clearTimeout(t); }, [value, delay]);
  return v;
}
